import { useVectorModal } from "../../../hooks/useVectorMemoryModal"

import { Box, ListItem, Radio, Typography } from "@mui/material"

import type { ChangeEvent } from "react"
import type { VectorEmbeddingModel } from "../../../types/vector"

interface EmbeddingModelItemProps {
	description: string
	info: string
	name: VectorEmbeddingModel
	selectedEmbeddingModel: VectorEmbeddingModel
	onEmbeddingModelChange: (evt: ChangeEvent<HTMLInputElement>) => void
}

function EmbeddingModelItem({
	description,
	info,
	name,
	selectedEmbeddingModel,
	onEmbeddingModelChange
}: EmbeddingModelItemProps) {
	const { isEditing } = useVectorModal()

	return (
		<label htmlFor={name}>
			<ListItem
				sx={{
					display: 'flex',
					alignItems: 'center',
					gap: '1rem',
					padding: '1.5rem',

					borderWidth: '1px',
					borderStyle: 'solid',
					borderColor: '#d4d4d4',
					borderRadius: '1rem',

					transition: 'all 200ms ease-in',

					'&:has(:checked)': {
						borderColor: '#3b82f6'
					},

					'&:has(:disabled)': {
						opacity: '50%',
						pointerEvents: 'none',
					}
				}}
			>
				<Radio
					checked={selectedEmbeddingModel === name}
					value={name}
					id={name}
					name="embedding-model"
					onChange={onEmbeddingModelChange}
					disabled={isEditing}
				/>

				<Box>
					<Box sx={{
						display: 'flex',
						gap: '0.5rem',
						fontSize: '1rem'
					}}>
						<Typography
							variant="h4"
							sx={{ fontSize: '1rem', fontWeight: 500 }}
						>
							{name}
						</Typography>

						<Typography>({info})</Typography>
					</Box>

					<Typography color="#475467">
						{description}
					</Typography>
				</Box>
			</ListItem>
		</label>
	)
}

export { EmbeddingModelItem }